// extracted by mini-css-extract-plugin
module.exports = {"lenkeInline":"LenkeInline_lenkeInline__Rxp_M"};